"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./SliderStyles"));
var Slider = function (_a) {
    var _b;
    var stepsWithLabels = _a.stepsWithLabels, showLabelsFor = _a.showLabelsFor, onChange = _a.onChange, color = _a.color, previousUsage = _a.previousUsage, previousUsageLabel = _a.previousUsageLabel, props = __rest(_a, ["stepsWithLabels", "showLabelsFor", "onChange", "color", "previousUsage", "previousUsageLabel"]);
    var sliderRef = React.useRef(null);
    var thumbRef = React.useRef(null);
    var miniThumbRef = React.useRef(null);
    var _c = React.useState(false), mouseDown = _c[0], setMouseDown = _c[1];
    var _d = React.useState(0), position = _d[0], setPosition = _d[1];
    var _e = React.useState(0), previousUsagePosition = _e[0], setPreviousUsagePosition = _e[1];
    var _f = React.useState(0), initialVal = _f[0], setInitialVal = _f[1];
    var steps = [];
    if (!props.steps && stepsWithLabels) {
        steps = stepsWithLabels.map(function (_a) {
            var value = _a.value;
            return value;
        });
    }
    else if (props.steps) {
        steps = props.steps;
    }
    var _g = React.useState(steps[0]), value = _g[0], setValue = _g[1];
    var diff = function (steps) {
        var diffArr = [];
        for (var i = 1; i < steps.length; i++) {
            diffArr.push(steps[i] - steps[i - 1]);
        }
        return diffArr;
    };
    var sum = function (diffArr) {
        var sum = 0;
        for (var i = 0; i < diffArr.length; i++) {
            sum += diffArr[i];
        }
        return sum;
    };
    var widths = function (diffArr) {
        if (sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) {
            var space = (sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.getBoundingClientRect().width) - diffArr.length * 10;
            var oneFlexGrow = space / sum(diffArr);
            var widthArr = [];
            for (var i = 0; i < diffArr.length; i++) {
                widthArr.push(10 + diffArr[i] * oneFlexGrow);
            }
            return widthArr;
        }
        else {
            return [];
        }
    };
    var diffArray = diff(steps);
    var getEndtype = function (idx) {
        if (idx === 0) {
            return "start";
        }
        else if (idx === diffArray.length - 1) {
            return "end";
        }
        else {
            return "default";
        }
    };
    var getLabel = function (value, thumbLabel) {
        var labelObj = stepsWithLabels === null || stepsWithLabels === void 0 ? void 0 : stepsWithLabels.find(function (label) { return label.value === value; });
        if (labelObj && ((showLabelsFor === null || showLabelsFor === void 0 ? void 0 : showLabelsFor.includes(labelObj.value)) || thumbLabel)) {
            return labelObj;
        }
        else {
            return undefined;
        }
    };
    var handleMouseMove = function (event) {
        if ((sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) && thumbRef.current) {
            var newX = event.clientX - (sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current.getBoundingClientRect().left);
            var end = sliderRef.current.offsetWidth - thumbRef.current.offsetWidth;
            var start = 0;
            if (newX < start) {
                newX = 0;
            }
            if (newX > end) {
                newX = end;
            }
            setPosition(newX);
            calcAndSetValue(newX);
        }
    };
    var handleMouseUp = function () {
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("mousemove", handleMouseMove);
        setMouseDown(false);
    };
    var handleMouseDown = function (event) {
        var _a;
        setMouseDown(true);
        if ((sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) && thumbRef.current) {
            setInitialVal(event.clientX - ((_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left));
        }
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    var calcAndSetValue = function (position) {
        var isRightMoving = initialVal < position ? true : false;
        var widthArray = widths(diffArray);
        var cumSumWidthArray = widthArray.reduce(function (a, x, i) { return __spreadArray(__spreadArray([], a, true), [x + (a[i - 1] || 0)], false); }, []);
        var idx = 0;
        cumSumWidthArray.forEach(function (widthValue, i) {
            if (position >= widthValue) {
                idx = isRightMoving ? i + 1 : i;
            }
        });
        var newValue = steps[idx + 1];
        setValue(newValue);
    };
    var calcAndSetPosition = function (value) {
        var widthArray = widths(diffArray);
        var cumSumWidthArray = widthArray.reduce(function (a, x, i) { return __spreadArray(__spreadArray([], a, true), [x + (a[i - 1] || 0)], false); }, []);
        var idx = 0;
        steps.forEach(function (stepValue, i) {
            if (value >= stepValue) {
                idx = i;
            }
        });
        setPosition(cumSumWidthArray[idx - 1] - 12);
        setInitialVal(cumSumWidthArray[idx - 1] - 12);
        if (previousUsage && stepsWithLabels) {
            var lastIndexValue = cumSumWidthArray[cumSumWidthArray.length - 1];
            var position_1 = (previousUsage * lastIndexValue) /
                stepsWithLabels[stepsWithLabels.length - 1].value;
            setPreviousUsagePosition(position_1 + 12);
        }
    };
    var selectByClick = function (value) {
        onChange(value);
        setValue(value);
        calcAndSetPosition(value);
    };
    React.useEffect(function () {
        if (!mouseDown) {
            calcAndSetPosition(value);
            onChange(value);
        }
    }, [mouseDown]);
    return (React.createElement(Styled.Container, { ref: sliderRef, hasLabels: Boolean(showLabelsFor) },
        diffArray.map(function (diff, idx) {
            var _a, _b;
            return (React.createElement(Styled.SliderElement, { grow: diff, endtype: getEndtype(idx), hoverDisabled: mouseDown, selected: value >= steps[idx + 1], color: color, onClick: function () { return selectByClick(steps[idx + 1]); }, key: "slider_elem_" + idx }, getLabel(steps[idx + 1]) && (React.createElement(Styled.SliderElementLabel, { last: ((_a = getLabel(steps[idx + 1])) === null || _a === void 0 ? void 0 : _a.value) === steps[steps.length - 1] }, (_b = getLabel(steps[idx + 1])) === null || _b === void 0 ? void 0 : _b.label))));
        }),
        !!previousUsage && (React.createElement(Styled.MiniThumb, { color: color, ref: miniThumbRef, position: previousUsagePosition },
            React.createElement(Styled.ThumbLabel, { mini: true, color: color }, previousUsageLabel))),
        React.createElement(Styled.Thumb, { color: color, ref: thumbRef, onMouseDown: function (e) {
                return handleMouseDown(e);
            }, position: position ? position : 0, mouseMove: mouseDown },
            React.createElement(Styled.ThumbLabel, { color: color }, (_b = getLabel(value, true)) === null || _b === void 0 ? void 0 : _b.label))));
};
exports.default = Slider;
